import Link from "next/link";

export default function Vacancy({ title, type, slug, location, exceprt }) {
  return (
    <section
      className="elementor-section elementor-inner-section elementor-element elementor-element-0c4f93c elementor-section-boxed elementor-section-height-default elementor-section-height-default"
      data-id="0c4f93c"
      data-element_type="section"
    >
      <div className="elementor-container elementor-column-gap-default">
        <div
          className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-f412505"
          data-id="f412505"
          data-element_type="column"
        >
          <Link
            rel="dofollow"
            href={`/careers/${slug}`}
            title={title}
            className="w-full p-6 mb-4 border-2 border-[#E23125] rounded-md"
          >
            <div className="flex gap-2 justify-between items-center">
              <div className="basis-3/4 elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-70a1f8b elementor-widget elementor-widget-heading"
                  data-id="70a1f8b"
                  data-element_type="widget"
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <h3 className="elementor-heading-title elementor-size-default">
                      {title}
                    </h3>
                  </div>
                </div>

                <div
                  className="elementor-element elementor-element-4444398 elementor-widget elementor-widget-text-editor"
                  data-id="4444398"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>{exceprt}</p>
                  </div>
                </div>
              </div>

              <div className="basis-1/4 elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-4444398 elementor-widget elementor-widget-text-editor"
                  data-id="4444398"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container grid place-items-end">
                    <div className="flex flex-row items-center justify-between">
                      {type} - {location}
                      <i className="fas fa-chevron-right text-4xl text-[#E23125] fa-7x ml-4"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
